const sponsorships = [
  {
    mobileName: 'Winner_Header',
    desktopName: 'winner',
    countryIds: [6],
    mobileUrl: 'https://m.winner.co.il/?utm_source=365scores&utm_medium=MWHPbutton&utm_campaign=APP&utm_content=MWHPbutton',
    desktopUrl: 'https://www.winner.co.il/?utm_source=365scores&utm_medium=DesktopHPbutton&utm_campaign=APP&utm_content=DesktopHPbutton',
  },
];

module.exports = sponsorships;
